import { createContext } from "react";

export const FirstInputFormDataContext = createContext("");
